const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/workItem.ts';
import { createSelector } from 'reselect';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { KisApiAction, ReducerState } from '@cistec/common_web/defs/actionTypes';
import {
    ACTION_TYPE_SET_LOGIN_DATA_AT_AUTO_LOGIN,
    GET_REGISTER_WORK_ITEM,
    REQUEST_ACTION_TYPES_GET_SMS_CODE_TOKEN,
} from 'App/actions/fixme.login.actionTypes';
import { GetTokenFromSmsCodeAction, SetLoginDataAtAutoLoginAction } from 'App/actions/fixme.login';
import { LoginData } from 'App/defs/loginDefs';
import {
    defaultInitialState,
    defaultKisApiActionFailure,
    defaultKisApiActionPending,
    defaultKisApiActionSuccess,
    getData,
    getDataAsMap,
    isAnyPendingOrLoading,
} from '@cistec/common_web/utils/redux4Requests';
import { WorkItem } from '@cistec/common_web/defs/kisim';
import { REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM } from 'App/actions/workItem';
import { useRemoteData } from '@cistec/common_web/hooks/useRemoteData';
import { invitationCode } from './login';
import _ from 'lodash';
import { nativeAccessToken } from './nativeAppAuth';
import { getCorrectEndpoint } from 'App/middleware/getCorrectEndpoint';
import { compileEndpoint } from '@cistec/common_web/actions/kisapi/utils';
import { fetchWithSpecialEndpointAndDispatch } from 'App/utils/fetchUtils';
import { PatAppStoreState } from './setup/rootReducer';
import { KeyValuePair } from '@cistec/common_web/defs/generalDefs';

const KEY_WORK_ITEM = 'workItem';
const KEY_AUFGEBOT = 'aufgebot';

const Log = Logger('workItemsReducer');

const finalizeECheckinSuccess = (state: ReducerState, action: KisApiAction) => {
    const keys = [KEY_WORK_ITEM, action.meta.workId];
    const workItem = state.getIn(keys);
    if (workItem) {
        const updatedWorkItem = { ...workItem };
        updatedWorkItem.STATUS = 'D';
        state = defaultKisApiActionSuccess(state, updatedWorkItem, keys);
    } else {
        // but why?
        state = defaultKisApiActionSuccess(state, undefined, keys);
    }
    return state;
};

const handleAufgebotWorkItemSuccess = (state: ReducerState, action: GetTokenFromSmsCodeAction) => {
    const aufgebotWorkId = action.payload?.kisim?.aufgebotWorkId;
    state = defaultKisApiActionSuccess(state, aufgebotWorkId, [KEY_AUFGEBOT]);
    return state;
};

const setLoginDataAtAutoLoginHandler = (state: ReducerState, action: SetLoginDataAtAutoLoginAction) => {
    const aufgebotWorkId = action.payload?.kisim?.aufgebotWorkId;

    if (!aufgebotWorkId) {
        Log.error('Missing AufgebotWorkId from payload!', action);
        sessionStorage.removeItem(LoginData);
        return state;
    }

    return handleAufgebotWorkItemSuccess(state, action as GetTokenFromSmsCodeAction);
};

const loadWorkItemSuccess = (state: ReducerState, action: KisApiAction) => {
    const workItem = action.payload;
    // WARNING: MANIPULATING RESPONSE
    workItem.ETAG = action.meta.etag;
    state = defaultKisApiActionSuccess(state, workItem, [KEY_WORK_ITEM, action.meta.workId]);
    return state;
};

export const workItemReducer = (state: ReducerState = defaultInitialState, action: KisApiAction) => {
    const { meta, payload, type } = action;
    switch (type) {
        case ACTION_TYPE_SET_LOGIN_DATA_AT_AUTO_LOGIN:
            state = setLoginDataAtAutoLoginHandler(state, action as SetLoginDataAtAutoLoginAction);
            break;
        case GET_REGISTER_WORK_ITEM.success:
        case REQUEST_ACTION_TYPES_GET_SMS_CODE_TOKEN.success:
            state = handleAufgebotWorkItemSuccess(state, action);
            break;
        //case FINALIZE_ECHECKIN.pending:
        case REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM.pending:
            state = defaultKisApiActionPending(state, [KEY_WORK_ITEM, action.meta.workId], action);
            break;
        //case FINALIZE_ECHECKIN.success:
        // state = finalizeECheckinSuccess(state, action);
        //break;
        case REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM.success:
            state = loadWorkItemSuccess(state, action);
            break;
        //case FINALIZE_ECHECKIN.failure:
        case REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM.failure:
            state = defaultKisApiActionFailure(state, [KEY_WORK_ITEM, action.meta.workId], action);
            break;
    }
    return state;
};

const selectWorkItemsMap = (state: PatAppStoreState): KeyValuePair<WorkItem> | undefined =>
    getDataAsMap(state.workItem, [KEY_WORK_ITEM]);

export const selectIsAnyWorkItemLoading = (state: PatAppStoreState): boolean =>
    isAnyPendingOrLoading(state.workItem, [KEY_WORK_ITEM]);

export const selectAufgebotWorkId = (state: PatAppStoreState) => getData(state.workItem, [KEY_AUFGEBOT]);

export const aufgebotWorkItem = createSelector(
    [selectWorkItemsMap, selectAufgebotWorkId],
    (workItemsMap, aufgebotWorkId: string) => {
        return aufgebotWorkId ? workItemsMap?.[aufgebotWorkId] : undefined;
    }
);

/*
export const getTerminNrFromPatAppRegister = createSelector(
    [patRegisterWorkId, selectWorkItemsMap],
    (workId: string, workItemsMap: GenericKeyValuePair): string | undefined => {
     const patnr = getPatNrFromSession();
        if (patnr) {
            return undefined;
        }
        return workItemsMap?.[workId]?.CONTENT?.TERMIN_INFO?.TERMINNR || null;
    }
);
*/

export function useECheckinRegisteredWorkItem() {
    return useRemoteData({}, () => ({
        isLoading: selectIsAnyWorkItemLoading,
        select: aufgebotWorkItem,
        shouldFetch: (state, _props, { isLoading }) => {
            const workId = selectAufgebotWorkId(state);
            const invCode = invitationCode(state);
            return _.isEmpty(workId) && !invCode && !isLoading;
        },
        fetch: (dispatch, state) => {
            const natAccessToken = nativeAccessToken(state);
            const endpoint = getCorrectEndpoint(state, compileEndpoint(['patapi', 'auth', 'ehrFromRegister']));
            fetchWithSpecialEndpointAndDispatch(
                endpoint,
                undefined,
                GET_REGISTER_WORK_ITEM,
                undefined,
                dispatch,
                natAccessToken
            );
        },
        noRefetch: true,
    }));
}
